import React from 'react';
import { SVGIcon } from '@superops/super-icons';
import { TextStyle, DisplayText, Tippy } from '@superops/ui-design-system';
import { injectIntl, FormattedMessage } from 'react-intl';
import { getTranslatedText, withErrorBoundary } from '@nile/components';

function RunbookNodeActivatorContent(props) {
  const intl = props?.intl;

  const {
    nodeType = '',
    nodeName = '',
    iconName = 'TaskModule',
    dynamicNodeName = false,
    callBackFunction = () => {},
    isAutoAction = false
  } = props;

  const nodeTypeIntl = getTranslatedText(intl, nodeType);

  const nodeTypeText = dynamicNodeName
    ? nodeName
      ? nodeName
      : nodeTypeIntl
    : nodeTypeIntl;

  const nodeNameText = dynamicNodeName ? '' : nodeName;

  return (
    <Tippy
      title={nodeName}
      duration={250}
      delay={200}
      arrow={false}
      theme="dark"
    >
      <div
        onClick={callBackFunction}
        onKeyDown={(e) => {}}
        role="button"
        tabIndex={0}
        className={`flex center fw ${isAutoAction ? 'p5' : 'p10'}`}
      >
        <div className="flex center fw">
          <span className="mr-10">
            <div className="ignoreOverride">
              <SVGIcon name={iconName} />
            </div>
          </span>
          <div className="ellipsis">
            <TextStyle variation="subdued" weight="Bold">
              <span>{nodeTypeText}</span>
            </TextStyle>

            {nodeNameText && (
              <div className="ellipsis">
                <TextStyle weight="Medium">
                  <span>{nodeNameText}</span>
                </TextStyle>
              </div>
            )}
          </div>
        </div>
      </div>
    </Tippy>
  );
}

export default withErrorBoundary(injectIntl(RunbookNodeActivatorContent));
